import apiClient from './client'

export interface LeaveType {
  id: string
  name: string
  color: string
  sort_order: number
}

export interface DriverLeaveEntry {
  id: string
  date: string
  leave_type_id: string
  leave_type_name: string
  leave_type_color: string
  note?: string
}

export interface DriverLeaveRow {
  driver_id: string
  driver_name: string
  leaves: DriverLeaveEntry[]
}

export const leaveApi = {
  listLeaveTypes: async (): Promise<LeaveType[]> => {
    const r = await apiClient.get<LeaveType[]>('/leaves/leave-types')
    return r.data
  },

  createLeaveType: async (data: { name: string; color: string }): Promise<LeaveType> => {
    const r = await apiClient.post<LeaveType>('/leaves/leave-types', data)
    return r.data
  },

  deleteLeaveType: async (id: string): Promise<void> => {
    await apiClient.delete(`/leaves/leave-types/${id}`)
  },

  listWeekly: async (from: string, to: string): Promise<DriverLeaveRow[]> => {
    const r = await apiClient.get<DriverLeaveRow[]>(`/leaves/driver-leaves?from=${from}&to=${to}`)
    return r.data
  },

  createLeave: async (
    driverId: string,
    data: { date: string; leave_type_id: string; note?: string },
  ): Promise<void> => {
    await apiClient.post(`/leaves/driver-leaves/${driverId}`, data)
  },

  deleteLeave: async (id: string): Promise<void> => {
    await apiClient.delete(`/leaves/driver-leaves/${id}`)
  },

  getOnDateDriverIds: async (date: string): Promise<string[]> => {
    const r = await apiClient.get<string[]>(`/leaves/driver-leaves/on-date?date=${date}`)
    return r.data
  },
}
